import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BarChart3, ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

/** Charts are collapsed by default on phones so lists stay one thumb-scroll away. */
const MobileInsights: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        className="flex w-full items-center gap-3 border-0 bg-white px-4 py-3 text-left active:bg-gray-50"
      >
        <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
          <BarChart3 className="h-4 w-4" />
        </span>
        <span className="flex-1 text-sm font-semibold text-gray-900">Insights</span>
        <ChevronDown
          className={cn("h-4 w-4 text-gray-400 transition-transform", open && "rotate-180")}
        />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <div className="space-y-3 border-t border-gray-100 p-3">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MobileInsights;
